export default __webpack_public_path__ + "static/media/default.3f289403.png";